import React, { useEffect, useState } from 'react'
import { Router, Switch, Route } from 'react-router-dom'
import Aside from 'components/Aside'
import { runtime } from 'rest/runtime'
import {FormattedMessage, useIntl} from "react-intl";
import messages from "./messages";

const NotificationsPage = ({ match, location }) => {
  const params = new URLSearchParams(location.search)
  const { formatMessage } = useIntl()

  if (!params.has('showNotifications')) {
    return null
  }

  const [notifications, setNotifications] = useState([])
  const [page, setPage] = useState(0)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    setLoading(true)
    fetch(`/rest/v1/notification?search[user_id]=${runtime.currentUser.get('uid')}?pageSize=20&page=${page}&orderField=uid&orderDirection=-1`)
      .then((response) => response.json())
      .then((list) => {
        setNotifications((notifications) => ([ ...notifications, ...list ]))
        setLoading(false)
      })
      .catch((err) => {
        window.alert(err)
        console.error(err)
      })
  }, [page])

  const onClose = () => {
    reactHistory.push(window.location.pathname)
  }

  if (loading) {
    return (
      <Aside>
        <div className="w-full h-full flex justify-center items-center">
          <i className="fa fa-sync animate-spin text-gray-600 text-2xl"></i>
        </div>
      </Aside>
    )
  }

  return (
    <Aside onClose={onClose}>
      <div className="w-full h-full flex flex-col overflow-scroll">
        <div className="relative grow h-full overflow-scroll">
          { notifications.map(({ uid, title, body, url, created_at, seen_at }) => (
            <div key={uid} className="bg-white border border-gray m-2 p-5 w-full cursor-default">
              <div className="flex justify-between items-center">
                <a href={url} target="_blank" className="truncate">
                  <div className="text-primary font-medium truncate">{ title }</div>
                </a>

                <div className="text-sm font-medium">{ created_at }</div>
              </div>

              <div className="">{ body }</div>
            </div>
          )) }
        </div>
        <div
          className="border-t border-gray-300 mt-3 text-center truncate font-medium text-primary hover:bg-blue-100 cursor-pointer py-4"
          onClick={() => setPage((page) => page + 1)}
        >
          <i className="fa fa-sync"></i><FormattedMessage {...messages.fetchMore}/>
        </div>
      </div>
    </Aside>
  )
}

export default NotificationsPage
